var map = {
	"./arrow_back.svg": "c731",
	"./arrow_right.svg": "d03c",
	"./call.svg": "180e",
	"./close.svg": "bf37",
	"./copied.svg": "8731",
	"./copy.svg": "553b",
	"./diseasesPreview.svg": "2fbf",
	"./dot.svg": "de15",
	"./email.svg": "9055",
	"./facebook.svg": "aaa3",
	"./fullscreen.svg": "8625",
	"./fullscreen_exit.svg": "6b3f",
	"./instagram.svg": "54e6",
	"./mail.svg": "1752",
	"./map.svg": "a086",
	"./menu.svg": "36be",
	"./phone.svg": "001e",
	"./russia.svg": "266f",
	"./schedule.svg": "6909",
	"./site.svg": "c340",
	"./telegram.svg": "7dd3",
	"./united-kingdom.svg": "b57c",
	"./whatsapp.svg": "3357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";